import axios from 'axios';

const API_URL = process.env.REACT_APP_VEXPO_API_URL;

const startRecording = (eventDomain: string, webinarId: string, webinar: any) => {
  axios.post(`${API_URL}/webinarAgora/${eventDomain}/webinars/${webinarId}/recording/start`, {
    agoraWebinar: webinar,
  })
    .then(({ data }) => {
      if (data.success) {
        console.log('Recording Started');
      }
    })
    .catch((error) => {
      console.log(error);
    });
};

export default startRecording;
